import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

interface IProps {
  paymentId: string;
  data: fhir5.PaymentNotice;
}

export async function PutPaymentNotice({ paymentId, data }: IProps) {
  const url = `${endpoints.ADMFHIR}/PaymentNotice/${paymentId}`;

  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .put(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`PutPaymentNotice: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("PutPaymentNotice", error);
      toast.error(`Erro ao atualizar PaymentNotice: ${error?.response?.status}`);
      throw new Error();
    });
  
  if (response) return response;
} 